/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Steps_TitleInputs */

const en_svc_agents_steps_title = /** @type {(inputs: Svc_Agents_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we build an agent.`)
};

const lv_svc_agents_steps_title = /** @type {(inputs: Svc_Agents_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā mēs veidojam aģentu.`)
};

/**
* | output |
* | --- |
* | "How we build an agent." |
*
* @param {Svc_Agents_Steps_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_steps_title = /** @type {((inputs?: Svc_Agents_Steps_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Steps_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_steps_title(inputs)
	return en_svc_agents_steps_title(inputs)
});